import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateEventProtocol, EventProtocol } from '../../../shared/interfaces/event.interfaces';

const basePath = '/event/protocols';

@Injectable({
  providedIn: 'root',
})

export class EventProtocolsService {
  constructor(private http: HttpClient) { }

  // Gets event protocols of current and parent dealer
  getEventProtocols(): Observable<EventProtocol[]> {
    return this.http.get<EventProtocol[]>(`${basePath}`);
  }

  // Creates a new event protocol for the current dealer
  createEventProtocol(payload: CreateEventProtocol): Observable<EventProtocol> {
    const body = payload;
    return this.http.post<EventProtocol>(`${basePath}`, body);
  }

  // Updates an existing event protocol
  updateEventProtocol(payload: EventProtocol) {
    const body = payload
    return this.http.put(`${basePath}`, body);
  }

  // Gets details of a specific event protocol
  getEventProtocolById(protocolId: number): Observable<EventProtocol> {
    return this.http.get<EventProtocol>(`${basePath}/${protocolId}`);
  }

  // Deletes an event protocol
  deleteEventProtocol(protocolId: number) {
    return this.http.delete(`${basePath}/${protocolId}`);
  }

}
